import { render, staticRenderFns } from "./app-skeleton.vue?vue&type=template&id=12abca0e"
import script from "./app-skeleton.ts?vue&type=script&lang=ts&external"
export * from "./app-skeleton.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports